import { combineTokens, makeScaleableToken } from '@utils/css';

const makeSizeTokens = (name = "--element-size", defaultSize = "100%") => combineTokens(name, {
  width: [typeof defaultSize === "object" && "width" in defaultSize ? defaultSize.width : defaultSize, makeScaleableToken],
  height: [typeof defaultSize === "object" && "height" in defaultSize ? defaultSize.height : defaultSize, makeScaleableToken]
});
const elementSizeTokens = makeSizeTokens();

export { elementSizeTokens, makeSizeTokens };
//# sourceMappingURL=size.selectors.js.map
